module.exports = __webpack_public_path__ + "static/img/effect_1.e25dfa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lp/effect_1.png
// module id = n6HZ
// module chunks = 3